/* eslint-disable import/no-cycle */
/* eslint-disable import/first */
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Drawer, ClickAwayListener, Button, Grid } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { GoogleMap, useLoadScript, InfoWindow } from '@react-google-maps/api';
import { Loader as GeoLoader } from '@googlemaps/js-api-loader';
import { useNavigate, useLocation } from '@reach/router';
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from '@reach/combobox';
import { GoLocation } from '@react-icons/all-files/go/GoLocation';
import { FiSearch } from '@react-icons/all-files/fi/FiSearch';
import { RiCloseLine } from '@react-icons/all-files/ri/RiCloseLine';
import { MdMyLocation } from '@react-icons/all-files/md/MdMyLocation';
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight';
import { AiOutlineArrowDown } from '@react-icons/all-files/ai/AiOutlineArrowDown';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import mapStyles from './mapStyles';
import OrderModesBar from '../../components/OrderModesBar';
import { ChangeLocationConfirm } from '../../components/SavedAddress';
import { Location, LocationPin, NoLocationPin, BWPin } from '../../components/Icons';

import DrawerPwa from '../../components/DrawerPwa';
import ChangeAddress from './ChangeAddress';
import {
  getFormatedResult,
  getcurrentCountry,
  geoCodeShortName,
} from 'spwa-ui-library/esm/utils/helper';
import PHBackButton from '../../components/PHBackButton';
import css from './index.module.scss';
import ClassNames from 'classnames';
import DrawerCountry from './DrawerCountry';
import Loader from '../../components/Loader';
import CountrySelection, { countryList } from '../../components/CountryDropdown';
import Skeleton from 'react-loading-skeleton';
import BackButton from '../../components/BackButton';

const { postAddress, validateLocation, fetchAddress } = Slices.addressSlice;
const { sendCart, cartItems, clearCart } = Slices.cartSlice;
const {
  selectCountryValidations,
  selectOrderModeIdx,
  selectBaseURL,
  selectOrderModesByCountry,
} = Slices.configSlice;

const {
  selectDesktop,
  handleCountryPopup,
  getAddressNavigation,
  handleAddressNavigation,
} = Slices.appSlice;
const { selectMenuById, selectFirstMenu } = Slices.menuSlice;
const { clearCustomizeItems } = Slices.tempCartSlice;

const libraries = ['places'];
const mapContainerStyle = {
  height: '100%',
  width: '100%',
};

const options = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: false,
  gestureHandling: 'greedy',
  clickableIcons: false,
};
const getCountryNameFromCode = (code) => {
  let countryName = code;
  for (let i = 0; i < countryList.length; i++) {
    if (countryList[i].code === code) {
      countryName = countryList[i].name;
      break;
    }
  }
  return countryName;
};

const checkInsideServicedCountry = (code) => {
  let result = false;
  for (let i = 0; i < countryList.length; i++) {
    if (countryList[i].code === code) {
      result = true;
      break;
    }
  }
  return result;
};

function AddAddress({ closePopUp }) {
  //Map key added  - used personal
  const intl = useIntl();
  const mapkey = process?.env?.REACT_APP_MAPS_API_KEY || '';

  //Geocoder Configurations
  const geoCoderLoadScript = async () => {
    const loader = new GeoLoader({
      apiKey: process?.env?.REACT_APP_MAPS_API_KEY || '',
      version: 'weekly',
      language: intl.locale,
      region: 'ae',
    });
    await loader.load();
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: mapkey,
    libraries,
    language: intl.locale,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const { oldLocation = JSON.parse(JSON.stringify(location)), retUrl = '/' } = location.state || [];
  const navigate = useNavigate();
  const { action = '' } = location.state || {};
  const imgBaseUrl = useSelector(selectBaseURL);
  const [stateOpen, setStateOpen] = React.useState(false);
  const [pageLoader, setPageLoader] = React.useState(false);
  const [notCurrentCountry, setNotCurrentCountry] = React.useState(false);
  const [servicedCountry, setServicedCountry] = React.useState(false);
  const [currentGeoLocationCountry, setCurrentGeoLocationCountry] = React.useState('');
  const [errorResponse, setErrorResponse] = React.useState('');
  const offer = useSelector((state) => state.offer);
  const couponCode = offer.apply ? offer.apply.couponCode : '';
  const auth = useSelector((state) => state.auth);
  const cartState = useSelector((state) => state.cart);
  const cart = useSelector(cartItems);
  const moveMapToDefault = useSelector(getAddressNavigation);

  const profile = useSelector((state) => state.profile);
  const store = useSelector((state) => state.store);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, profile.country)
  );
  const PageSelectedMode = useSelector((state) =>
    selectOrderModeIdx(state, profile.country, 'DELIVERY')
  );
  const [center, setCenter] = React.useState({
    lat: countryValidations?.defaultLat,
    lng: countryValidations?.defaultLng,
  });
  const isDesktop = useSelector(selectDesktop);
  const [markers, setMarkers] = useState([
    { lat: countryValidations?.defaultLat, lng: countryValidations?.defaultLng },
  ]);
  const orderModes = useSelector((state) => selectOrderModesByCountry(state, profile.country));
  const [addInfo, setAddInfo] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [bldNu, setBldNu] = useState('');
  const [flatNu, setFlatNu] = useState('');
  const [howTo, setHowTo] = useState('');
  const [cartDropPopup, setCartDropPopup] = useState();
  const [status, setStatus] = useState('initial');
  const [openCountry, setOpenCountry] = useState(false);
  const [countryDefault, setCountryDefault] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [validateMenuDetail, setValidateMenuDetail] = useState({});
  const [tag, setTag] = useState('HOME');
  const [validateError, setValidateError] = useState('');
  const height = window && window.innerHeight;
  const [calculatedHeight, setCalculatedHeight] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(0);
  const menu = useSelector(selectFirstMenu);

  const allTags = [
    { id: 'HOME', val: intl.formatMessage({ id: 'home_tag' }) },
    { id: 'OFFICE', val: intl.formatMessage({ id: 'office_tag' }) },
    { id: 'HOTEL', val: intl.formatMessage({ id: 'hotel_tag' }) },
    { id: 'OTHER', val: intl.formatMessage({ id: 'trackorder_others' }) },
  ];
  const addreessLocationPlaceholder = intl.formatMessage({ id: 'addaddress_addresslocation' });
  const buildingPlaceholder = intl.formatMessage({ id: 'building_name' });
  const flatNoPlaceholder = intl.formatMessage({ id: 'flat_no' });
  const howToReachpl = intl.formatMessage({ id: 'how_to_reach' });
  const searchLocation = intl.formatMessage({ id: 'addaddress_searchlocation' });
  // const placeholder = intl.formatMessage({ id: 'addaddress_addresslocation' });
  const [selected, setSelected] = useState(null);
  let poly = null;
  const [servicedCountryPolygons, setServicedCountryPolygons] = useState({});
  const contrySpecificValidation = useSelector(
    (state) => state.config?.data?.data?.contrySpecificValidation
  );

  useEffect(() => {
    let polygons = {};
    // polygons[result.data.country] = result.data.data;
    // eslint-disable-next-line no-unused-expressions
    contrySpecificValidation?.forEach((country) => {
      polygons[country?.country] = country?.countryGeoFenceCoords?.map((data) => ({
        lat: data[0],
        lng: data[1],
      }));
    });
    setServicedCountryPolygons(polygons);
  }, [contrySpecificValidation]);

  useEffect(() => {
    if (height && headerHeight) {
      setCalculatedHeight(`${height - headerHeight}px`);
    }
  }, [height, headerHeight]);

  const handleClickAway = () => {
    setStateOpen(false);
    //    setAddInfo(false);
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  };

  const changeSearch = () => {
    setAddInfo(false);
    //    setAddInfo(false);
  };
  const openDrawerCountry = () => {
    // setOpenCountry((prev) => !prev);
    dispatch(handleCountryPopup());
  };

  const shouldNotUpdateDefaultAddress = () => {
    return (
      window.location.search.split('&').filter((term) => term.includes('no-update=true')).length > 0
    );
  };
  const cartSend = (payload) => {
    return '';
  };
  const handleForm = () => {
    if (closePopUp) {
      closePopUp();
    }
    setStatus('loading');
    setPageLoader(true);
    const addressPayload = {
      addressSubType: 'DELIVERY',
      addressType: 'DELIVERY',
      addressVia: 'DEFAULT',
      bldgName: bldNu,
      description: markers[0].address,
      flatNum: flatNu,
      howToReach: howTo,
      lat: markers[0].lat,
      lng: markers[0].lng,
      tag: tag.toUpperCase(),
      isNotDefaultSelected: shouldNotUpdateDefaultAddress(),
    };
    dispatch(postAddress(addressPayload)).then((addRespons) => {
      if (addRespons.meta.requestStatus !== 'rejected') {
        if (!shouldNotUpdateDefaultAddress()) {
          window.localStorage.setItem('_add', JSON.stringify(addRespons?.payload?.data?.data));
        }
        const cartLocation = {
          ...location,
          href: location.origin,
          pathname: `/${intl.local}/cart`,
        };
        const payload = {
          body: {
            addressSubType: 'DELIVERY',
            addressType: 'DELIVERY',
            addressId: addRespons?.payload?.data?.data?.id || '',
            cartId: profile.data.data[0].cartId,
            applySurprisePromo: couponCode?.length > 0,
            clusterId: cartState.data.clusterId || '',
            items: cart,
            version: 'v20',
            orderType: 'DELIVERY',
            storeId: addRespons?.payload?.data?.data?.storeId,
          },
          headers: {
            country: profile.country,
          },
        };
        console.log(`cart -- `, cart);
        debugger;
        if (cart.length || 0) {
          // cartSend(payload);
          dispatch(sendCart(payload));
        }
        dispatch(fetchAddress()).then((resp) => {});
        if (!isDesktop) {
          if (action === 'select') {
            navigate(`/${intl.locale}/checkout`, { replace: true });
          } else {
            if (retUrl !== '/') {
              navigate(`/${intl.locale}${retUrl}`, { replace: true });
            } else {
              navigate(-1);
            }
          }
        } else {
          if (retUrl !== '/') {
            navigate(`/${intl.locale}${retUrl}`, {
              state: { oldLocation: cartLocation },
            });
          } else {
            if (location?.search?.indexOf('bundleGroup') > -1) {
              navigate(-1, { replace: true });
            } else {
              navigate(location.pathname, { replace: true });
            }
          }
        }
      } else {
        setAddInfo(false);
        setStateOpen(true);
        setErrorResponse(addRespons.error.message);
      }
      setPageLoader(false);
    });
  };

  const getCurrentLoc = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => successPosition(pos),
        (err) => deniedPosition(err)
      );
    } else {
      alert("Your Browser doesn't support location service !");
    }
  };

  useEffect(() => {
    if (markers.length) {
      const payload = {
        lat: markers[0].lat,
        lng: markers[0].lng,
        screen: 'LOCATION',
        addressSubType: 'DELIVERY',
      };
      dispatch(validateLocation(payload)).then((resp) => {
        if (resp.error) {
          setValidateError(resp.error.message);
        } else {
          if (resp.payload.data.data.store.services.del === 0) {
            setValidateError('Sorry Store Doesnt Deliver Here Yet');
          } else {
            setValidateError('');
            setValidateMenuDetail({
              menuId: resp.payload.data.data.menuId,
              menuTempId: resp.payload.data.data.menuTempId,
            });
          }
        }
      });
    }
  }, [dispatch, markers]);

  const successPosition = useCallback(async (position) => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    await updateLocation(lat, lng);

    setCenter({
      lat: lat,
      lng: lng,
    });
    // if (mapRef.current) {
    //   mapRef.current.setZoom(16);
    // }
  });
  useEffect(() => {
    if (countryDefault) {
      const newPos = {
        coords: {
          latitude: countryValidations.defaultLat,
          longitude: countryValidations.defaultLng,
        },
      };

      setTimeout(() => {
        successPosition(newPos);
        setCountryDefault(false);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryDefault]);
  useEffect(() => {
    if (moveMapToDefault && pageLoaded) {
      const newPos = {
        coords: {
          latitude: countryValidations.defaultLat,
          longitude: countryValidations.defaultLng,
        },
      };

      setTimeout(() => {
        successPosition(newPos);
      }, 500);
      dispatch(handleAddressNavigation());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moveMapToDefault, pageLoaded]);

  const deniedPosition = useCallback(async (error) => {
    if (
      !pageLoaded &&
      store.status === 'succeeded' &&
      profile.status === 'succeeded' &&
      cartState.status === 'succeeded'
    ) {
      const newLat = markers[0].lat;
      const newLang = markers[0].lng;

      await updateLocation(newLat, newLang);
      alert(intl.formatMessage({ id: 'location_denied' }));
    }
    setShowSkeleton(false);
    setPageLoaded(true);
  });

  useEffect(() => {
    if (markers[0] && bldNu && flatNu) {
      setStatus('fullfilled');
    }
  }, [markers, bldNu, flatNu, howTo]);

  const mapRef = useRef();
  const onMapLoad = useCallback(
    (map) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => successPosition(pos),
          (err) => deniedPosition(err)
        );
      } else {
        alert("Your Browser doesn't support location service !");
      }
      mapRef.current = map;
    },
    [deniedPosition, successPosition]
  );

  const panTo = useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(18);
  }, []);

  // if (loadError) return 'Error';
  // if (!isLoaded) return 'Loading...';

  function Search({ panTo }) {
    const {
      ready,
      value,
      suggestions: { status, data },
      setValue,
      clearSuggestions,
    } = usePlacesAutocomplete({
      requestOptions: {
        location: { lat: () => 25.204849, lng: () => 55.270782 },
        radius: 100 * 1000,
        language: intl.locale,
        componentRestrictions: {
          country:
            profile.country === 'UAE' ? 'ae' : countryValidations?.shortCountryName?.toLowerCase(),
        },
      },
    });
    const [selectedHover, setSelectedHover] = useState([{}]);
    const handelHover = (id) => {
      setSelectedHover([{ [id]: !selectedHover[id] }]);
    };
    const handleInput = (e) => {
      setValue(e.target.value);
    };
    const getAddressValue = (terms) => {
      let value = [];
      terms.length &&
        terms.map((el) => {
          value.push(el.value);
        });
      return value.join(',');
    };
    const handleSelect = async (address) => {
      setValue(address, false);
      clearSuggestions();
      try {
        const results = await getGeocode({ address });
        const { lat, lng } = await getLatLng(results[0]);
        panTo({ lat, lng });
        setMarkers([
          {
            lat: lat,
            lng: lng,
            address: results[0].formatted_address,
          },
        ]);
      } catch (error) {
        // TODO: Handle error scenario with a toast message to the user
        console.log('Error: ', error);
      }
    };

    return (
      <div className={css.search}>
        <Combobox onSelect={handleSelect}>
          <FiSearch size="20px" className={css.icon} />
          <ComboboxInput
            value={value}
            onChange={handleInput}
            disabled={!ready}
            placeholder={searchLocation}
            id="search_location"
          />
          <div className={css.countryDrop}>
            <CountrySelection showName={false} />
          </div>
          {value && (
            <RiCloseLine size="2rem" className={css.closeIcon} onClick={() => setValue('')} />
          )}
          <ComboboxPopover portal={false} className={css.comboPop}>
            {data.length > 0 ? (
              <ComboboxList className={css.searchSugg}>
                {status === 'OK' &&
                  data.map(({ place_id, terms }) => {
                    const addressDetail = getAddressValue(terms);
                    return (
                      <ComboboxOption
                        key={`map-combo-${Math.random()}-${terms[0].value}`}
                        value={addressDetail}
                        className={css.optionBox}
                      >
                        <div
                          className={css.optionItem}
                          onMouseEnter={() => handelHover(place_id)}
                          onMouseLeave={() => handelHover(!place_id)}
                        >
                          <div className={css.iicon}>
                            <GoLocation size="18px" />
                          </div>
                          <div className={css.locTitle}>
                            {terms[0].value}
                            <span>
                              {terms[1]?.value} - {terms[2]?.value}
                            </span>
                          </div>
                          {Object.keys(selectedHover[0])[0] === place_id && (
                            <div className={css.iconRight}>
                              <FiArrowRight size={'20px'} />
                            </div>
                          )}
                        </div>
                      </ComboboxOption>
                    );
                  })}
                {/* {data.length === 0 && (
                <ComboboxOption key="noResultFound" value={0}>
                  <span>No Result Found</span>
                </ComboboxOption>
              )} */}
              </ComboboxList>
            ) : (
              <>
                {status && (
                  <>
                    <span className={css.noAddressFound}>
                      {intl.formatMessage({ id: 'address_noResultFound' })}
                    </span>
                    <div className={css.comboChangeCity}>
                      <div className={css.pin}>
                        <NoLocationPin />
                      </div>
                      <div className={css.textBlock}>
                        <div className={css.text}>
                          <FormattedMessage
                            id="address_locationOutside"
                            values={{
                              country: intl.formatMessage({ id: profile?.country }),
                            }}
                          />
                        </div>
                        <div className={css.action}>
                          <Button onClick={() => setValue('')} variant="outlined" color="primary">
                            {intl.formatMessage({ id: 'address_no' })}
                          </Button>
                          <Button onClick={openDrawerCountry} variant="contained" color="primary">
                            {intl.formatMessage({ id: 'address_yes' })}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </ComboboxPopover>
        </Combobox>
      </div>
    );
  }
  const handleLogin = () => {
    const ret = isDesktop ? '/home?modal=addaddress' : '/delivery';
    navigate(`/${intl.locale}/login`, {
      state: { oldLocation: oldLocation, retUrl: ret },
      replace: true,
    });
  };

  const checkLocationInsidePolygon = async (location, polygonData) => {
    if (!isLoaded) return false;
    if (!poly) ({ poly } = await window.google.maps.importLibrary('geometry'));
    const polygon = new window.google.maps.Polygon({ paths: polygonData });
    return poly.containsLocation(location, polygon);
  };

  const updateLocation = async (lat, lng) => {
    const currentLocation = new window.google.maps.LatLng(lat, lng);
    const countries = countryList.reduce((result, country) => {
      result = result.concat(country.code);
      return result;
    }, []);

    let isInsideServicedCountry = false;
    for await (let country of countries) {
      if (await checkLocationInsidePolygon(currentLocation, servicedCountryPolygons[country])) {
        isInsideServicedCountry = true;
        setServicedCountry(country);
        break;
      } else {
        isInsideServicedCountry = true;
        setServicedCountry(country);
        break;
      }
    }

    if (isInsideServicedCountry) {
      // check if location is in current profile country or not
      try {
        await geoCoderLoadScript();
        const geocoder = new window.google.maps.Geocoder();
        const { results } = await geocoder.geocode({ location: { lat, lng } });

        if (results && results[0]) {
          let formatedAddr = getFormatedResult(results);
          let countryCode = geoCodeShortName[getcurrentCountry(results)];

          if (countryCode == profile.country) {
            // inside current country
            setNotCurrentCountry(false);
            setServicedCountry(true);
            setMarkers([
              {
                lat: lat,
                lng: lng,
                address: formatedAddr,
              },
            ]);
          } else if (checkInsideServicedCountry(countryCode)) {
            // not inside current country but in serviceable country
            setNotCurrentCountry(true);
            setServicedCountry(true);
          } else {
            // not inside any serviceable country
            setNotCurrentCountry(true);
            setServicedCountry(false);
          }
          setCurrentGeoLocationCountry(countryCode);
        }
      } catch (error) {}
    } else {
      setNotCurrentCountry(true);
      setServicedCountry(false);
      setCurrentGeoLocationCountry(null);
    }
  };

  const handleBoundsChanged = async () => {
    try {
      const mapCenter = mapRef?.current?.getCenter();
      if (mapRef?.current) {
        //get map center
        const lat = mapCenter.lat();
        const lng = mapCenter.lng();
        await updateLocation(lat, lng);
      }
    } catch (error) {}
    setShowSkeleton(false);
  };
  const changeMap = (type) => {
    //setAddInfo(!addInfo);
    type === 'complete' && setAddInfo(!addInfo);
    document.getElementById('search_location').focus();
  };

  const Icon = orderModes.find((val) => val.type === 'DELIVERY')?.imageAlt;
  const checkMenuChange = () => {
    if (
      (validateMenuDetail.menuId !== menu?.menuId ||
        validateMenuDetail.menuTempId !== menu?.menuTemplateId) &&
      cart.length > 0
    ) {
      setCartDropPopup(true);
    } else {
      setAddInfo(true);
    }
    // setAddInfo(true);
  };

  const debouncedHandleBoundsChange = () => {
    setShowSkeleton(true);
    debounce(handleBoundsChanged, 1000)();
  };

  const debouncedDragChange = () => {
    setShowSkeleton(true);
    debounce(handleBoundsChanged, 500)();
  };

  const handleBack = () => {
    navigate(`/${intl.locale}/home`, {
      state: { oldLocation: oldLocation || location },
      replace: true,
    });
  };

  return (
    <div className={css.root}>
      {/* <TopBar heading="Add Address" /> */}
      <ChangeLocationConfirm
        isOpen={cartDropPopup}
        onCancel={() => {
          setCartDropPopup(false);
        }}
        onConfirm={() => {
          setCartDropPopup(false);
          setAddInfo(true);
        }}
      />
      {pageLoader && <Loader />}
      {!isDesktop && (
        <Grid className={css.headerContainer}>
          <Grid className={css.headerRoot}>
            {/* <BackButton className={css.backButton} handleBack={handleBack} /> */}
            <PHBackButton onclick={handleBack} classname={css.backButton} />
            <OrderModesBar action={action} defaultModeIdx={PageSelectedMode} />
          </Grid>
          {!isDesktop && <Search panTo={panTo} />}
        </Grid>
      )}

      {isDesktop && (
        <div className={css.desktopHeader}>
          {/* <div className={css.icon}>
            <img src={`${imgBaseUrl.home}${Icon}`} alt="" />
          </div> */}
          <div className={css.heading}>
            {' '}
            <FormattedMessage
              id="header_delivery_heading"
              defaultMessage="Select Delivery Location"
            />
          </div>
          <div className={css.Closebutton}>
            <Button onClick={closePopUp}>
              <IoMdClose />
            </Button>
          </div>
        </div>
      )}

      <main className={css.main} style={{ height: (!isDesktop && calculatedHeight) || 'auto' }}>
        <div className={css.section}>
          <div className={css.addAddress}>
            <div className={css.Map}>
              <div className={css.customMarker}>
                <LocationPin />
              </div>
              {isDesktop && <Search panTo={panTo} />}
              {isLoaded && !loadError && (
                <GoogleMap
                  id="map"
                  mapContainerStyle={mapContainerStyle}
                  zoom={10}
                  options={options}
                  onLoad={onMapLoad}
                  // onClick={onMapClick}
                  center={center}
                  defaultCenter={center}
                  ref={mapRef}
                  onZoomChanged={debouncedHandleBoundsChange}
                  onDragEnd={debouncedDragChange}
                >
                  <div
                    className={ClassNames(css.setLoc, { [css.notLoggedIn]: !auth.isLoggedIn })}
                    onClick={getCurrentLoc}
                  >
                    <MdMyLocation />
                  </div>
                  {selected ? (
                    <InfoWindow
                      position={{ lat: selected.lat, lng: selected.lng }}
                      onCloseClick={() => {
                        setSelected(null);
                      }}
                    ></InfoWindow>
                  ) : null}
                </GoogleMap>
              )}
            </div>

            <div className={css.addressForm}>
              {!auth.isLoggedIn && (
                <div className={css.loginBar}>
                  <div className={css.text}>
                    <FormattedMessage
                      id="login_savedAddresses"
                      defaultMessage="Login to use your saved addresses"
                    />
                  </div>
                  <Button
                    className={css.loginButton}
                    variant="contained"
                    color="primary"
                    onClick={handleLogin}
                  >
                    <FormattedMessage id="navigation_login" defaultMessage="login" />
                  </Button>
                </div>
              )}
              {!notCurrentCountry ? (
                <>
                  <div className={css.loc}>
                    <div className={css.locIcon}>
                      <BWPin />
                    </div>
                    <div className={css.selectedLoc}>
                      <div className={css.selectLocContainer}>
                        <h4>
                          <FormattedMessage
                            id="addaddress_selectlocation"
                            defaultMessage=" Select Location"
                          />
                        </h4>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => changeMap('select')}
                          className={css.change}
                        >
                          <FormattedMessage id="feedback_change" defaultMessage="CHANGE" />
                        </Button>
                      </div>
                      {showSkeleton ? (
                        <Skeleton count={1} className={css.Skeleton} />
                      ) : (
                        <>
                          <input
                            className={css.locationInput}
                            value={markers[0] ? markers[0].address : ''}
                            disabled
                            type="text"
                            placeholder={addreessLocationPlaceholder}
                          />
                          {validateError && <div className={css.warning}>{validateError}</div>}
                        </>
                      )}
                      {!validateError &&
                        Object.keys(markers[0]).length > 0 &&
                        markers[0].address === '' && (
                          <div className={css.warning}>
                            <FormattedMessage
                              id="please_choose_a_location"
                              defaultMessage="Please choose a location"
                            />
                          </div>
                        )}
                    </div>
                  </div>
                  <Button
                    className={css.button}
                    variant="contained"
                    color="primary"
                    onClick={() => checkMenuChange()}
                    disabled={markers.length === 0 || validateError || markers[0].address === ''}
                  >
                    <FormattedMessage
                      id="addaddress_confirmlocation"
                      defaultMessage="Confirm Location"
                    />
                  </Button>
                </>
              ) : (
                <>
                  {
                    <div className={css.loc}>
                      <div className={css.locIcon}>
                        <BWPin />
                      </div>
                      <div className={css.selectedLoc}>
                        <div className={css.noloc}>
                          <h3>
                            <FormattedMessage
                              id="addAddress_DeliveryLocation"
                              defaultMessage="Delivery Location test"
                            />
                          </h3>
                          <p>
                            {servicedCountry ? (
                              <>
                                <FormattedMessage
                                  id={'addAddress_DeliveryLocation_description_serviceable_one'}
                                  defaultMessage=""
                                />
                                {getCountryNameFromCode(profile?.country)}
                                <FormattedMessage
                                  id={'addAddress_DeliveryLocation_description_serviceable_two'}
                                />
                                {getCountryNameFromCode(currentGeoLocationCountry)}
                              </>
                            ) : (
                              <FormattedMessage id={'addAddress_DeliveryLocation_description'} />
                            )}
                          </p>
                          {servicedCountry && (
                            <div className={[css.warning, css.no_margin].join(' ')}>
                              <FormattedMessage
                                id={'addAddress_DeliveryLocation_description_warning'}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  }

                  <Button
                    className={css.button}
                    variant="contained"
                    color="primary"
                    onClick={openDrawerCountry}
                  >
                    <FormattedMessage id="changeCountry" defaultMessage="Change Country" />
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
        <Drawer variant="persistent" className={css.nobg} anchor="bottom" open={stateOpen}>
          <ClickAwayListener onClickAway={handleClickAway}>
            <div className={css.errorDrawer}>
              <div className={css.topPos}>
                <div className={css.strip}></div>
                <div className={css.strip}></div>
                <div className={css.strip}></div>
              </div>
              <div className={css.error}>{errorResponse ? errorResponse : null}</div>
              <Button className={css.ErrorB} onClick={handleClickAway}>
                <FormattedMessage id="close" defaultMessage="Close" />
              </Button>
            </div>
          </ClickAwayListener>
        </Drawer>

        {openCountry && (
          <DrawerCountry
            setCountryDefault={setCountryDefault}
            openDrawerCountry={openDrawerCountry}
          />
        )}
        {!isDesktop && (
          <DrawerPwa
            ModalProps={{
              style: {
                position: 'absolute',
              },
            }}
            variant="temporary"
            anchor="bottom"
            onClose={changeSearch}
            className={css.nobg}
            open={addInfo}
          >
            <ChangeAddress
              markers={markers}
              changeMap={changeMap}
              setBldNu={setBldNu}
              bldNu={bldNu}
              buildingPlaceholder={buildingPlaceholder}
              setFlatNu={setFlatNu}
              flatNu={flatNu}
              flatNoPlaceholder={flatNoPlaceholder}
              setHowTo={setHowTo}
              howTo={howTo}
              howToReachpl={howToReachpl}
              allTags={allTags}
              setTag={setTag}
              tag={tag}
              handleForm={handleForm}
              status={status}
              buttonText={'addaddress_addadress'}
            />
          </DrawerPwa>
        )}
      </main>
      {isDesktop && addInfo && (
        <div className={ClassNames(css.openDrawerInfo, { [css.activeDrawer]: addInfo })}>
          <div className={css.closeButton} onClick={changeSearch}>
            <AiOutlineArrowDown size=".8em" />
          </div>
          <ChangeAddress
            markers={markers}
            changeMap={changeMap}
            setBldNu={setBldNu}
            bldNu={bldNu}
            buildingPlaceholder={buildingPlaceholder}
            setFlatNu={setFlatNu}
            flatNu={flatNu}
            flatNoPlaceholder={flatNoPlaceholder}
            setHowTo={setHowTo}
            howTo={howTo}
            howToReachpl={howToReachpl}
            allTags={allTags}
            setTag={setTag}
            tag={tag}
            handleForm={handleForm}
            status={status}
            buttonText={'addaddress_addadress'}
          />
        </div>
      )}
      <footer className={css.footer}></footer>
    </div>
  );
}

export default AddAddress;
